<template>
  <div>
    <div ref="googleBtn"></div>
    <!-- <div id="g_id_onload"
      :data-client_id="gid"
      data-context="signin"
      data-ux_mode="popup"
      data-callback="handleCredentialResponse"
      data-auto_prompt="false">
    </div> -->

    <!-- <div
      class="g_id_signin"
      data-type="icon"
      data-shape="circle"
      data-theme="outline"
      data-text="signin"
      data-size="medium">
    </div> -->
  </div>
</template>

<script>
// import { closeDialog } from '../../utils/Qtbridge'
export default {
  name: 'Google',
  props: {
    account: String
  },
  data () {
    return {
      userInfo: {},
      googleAuth: null,
      isOverIFrame: false,
      iframe: null,
      count: 0
    }
  },
  created () {
    this.initGoogle()
  },
  mounted () {
    this.renderBtn()
    setTimeout(() => {
      this.init()
    }, 200)
  },
  activated () {
    this.renderBtn()
  },
  methods: {
    renderBtn () {
      this.$refs.googleBtn.innerHTML = ''
      window.google.accounts.id.renderButton(
        this.$refs.googleBtn, // Ensure the element exist and it is a div to display correcctly
        { shape: 'circle', size: 'medium', type: 'icon' }  // Customization attributes
      )
    },
    initGoogle () {
      const gid = JSON.parse(window.localStorage.getItem('sdkParams') || '{}').gid
      window.google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GOOGLE_ID || this.$ENUM.GOOGLE_ACCOUNT_MAP[gid], // Replace with your Google Client ID
        context: 'login',
        ux_mode: 'popup',
        auto_prompt: false,
        callback: this.handleCredentialResponse // We choose to handle the callback in client side, so we include a reference to a function that will handle the response
      });
    },
    init () {
      // 曲线救国  监听 google 点击事件
      if (this.count++ > 3) return
      this.iframe = document.getElementsByTagName('iframe')[0]
      if (!this.iframe) {
        setTimeout(() => {
          this.init()
        }, 200)
        return
      }
      // 鼠标移入 iframe 记录 isOverIFrame
      this.$utils.bindEvent(this.iframe, 'mouseenter', this.enter)
      // 鼠标移出 iframe 后 isOverIFrame = false
      this.$utils.bindEvent(this.iframe, 'mouseout', this.out)
      // 监听 window 的点击事件（捕获阶段）, 同时判断此时鼠标是否在 iframe 内, 来判断是否为 iframe 内的点击
      this.$utils.bindEvent(window, 'blur', this.blur, true)
    },
    enter () {
      window.focus()
      this.isOverIFrame = true;
    },
    out () {
      this.isOverIFrame = false
    },
    blur () {
      if (!this.isOverIFrame) return
      this.$utils.log('pc_login_action', {
        login_action: 'click_google'
      })
    },
    handleCredentialResponse (response) {
      const payload = this.decodeJwtResponse(response.credential)

      this.userInfo = {
        id: payload.sub,
        name: payload.email,
        token: response.credential,
        type: this.$ENUM.SOCIAL_MAP.GOOGLE,
        expire: (payload.exp || 0) - (payload.iat || 0)
      }
      this.login()
    },
    decodeJwtResponse (token) {
      var base64Str = token.split('.')[1];
      var base64 = base64Str.replace(/-/g,'+').replace(/_/g,'/')
      return JSON.parse(window.atob(base64))
    },
    login () {
      this.$router.push({
        name: 'OauthResult',
        params: {
          type: 'success',
          loginData: this.userInfo
        }
      })
    }
  },
  beforeDestroy () {
    window.handleCredentialResponse = null
    if (this.$utils.unBindEvent) {
      this.$utils.unBindEvent(this.iframe, 'mouseenter', this.enter)
      this.$utils.unBindEvent(this.iframe, 'mouseout', this.out)
      this.$utils.unBindEvent(window, 'blur', this.blur, true)
    }
  }
}
</script>

<style lang='less' scoped >
.login {
  width: 31px;
  height: 31px;
  background: url(~@img/icon_google.png) center center no-repeat;
  background-size: 100% 100%;
}
</style>
